import { useHistory } from "react-router";
import { ResumoEvento } from "../components/ResumoEvento";
import { useAuth } from "../hooks/useAuth";
import { useEventos } from "../hooks/useEventos";

export function Eventos() {
    const { user } = useAuth();

    const modulos = useEventos(false);

    const history = useHistory();

    function handleCadastrar() {
        history.push("/cadastrar-evento");
    }

    return (
        <div className="content-wrapper">
            <div className="content-heading">
                Administrar Eventos
                <div className="ml-auto">
                    <button className="btn btn-secondary btn-sm" type="button" onClick={handleCadastrar}>
                        Cadastrar evento
                    </button>
                </div>
            </div>
            {/*(user === undefined || user.tipo !== "admin") && (
                <div className="row">
                    <div className="col-12">
                        <div className="denied alert alert-danger fade show" role="alert">
                            Acesso negado!
                        </div>
                    </div>
                </div>
            )*/}
            {user && (
                <div className="row">
                    {modulos &&
                        modulos.map((instance, index) => {
                            return (
                                <ResumoEvento
                                    key={index}
                                    id={instance.id}
                                    titulo={instance.titulo}
                                    data={instance.data}
                                    ocupacao={Object.values(instance.inscricoes ?? {}).filter((value) => !value.removidoPor).length}
                                    inscricoes={instance.inscricoes}
                                    status={"Confirmado"}></ResumoEvento>
                            );
                        })}
                </div>
            )}
        </div>
    );
}
